const Colors = [
    [
        "#10120F",
        "#F60129",
        "#878673",
        "#FEF361",
        "#FEF361",
        "#327CC7",
        "#E7E8EF",
    ],
    [
        "#10120F",
        "#F44A0F",
        "#0E8DD2",
        "#10971F",
        "#5AA316",
        "#E53F0F",
    ],
    [
        "#221816",
        "#FABF01",
        "#125FAF",
        "#01886A",
        "#6B5B99",
        "#E90013",
        "#FAEAD1",
    ],
    [
        "#03050B",
        "#01517B",
        "#FFC300",
        "#FF0B01",
        "#FD9746",
    ],
    [
        "#142A36",
        "#F0C667",
        "#7BA6BC",
        "#D24C23",
        "#672B35",
    ],
    [
        "#020202",
        "#00BB70",
        "#0075CA",
        "#FDDC3F",
        "#FF6936",
    ],
    [
        "#aa3941",
        "#d5a630",
        "#dd7440",
        "#1bdf84",
    ],
   
    [
        "#2A1F1D",
        "#F0E0C6",
        "#DF4A33",
        "#FBAF3C",
        "#2A1F1D",
        "#7A999C",
        "#475B62",
    ],
    [
        "#022D8F",
        "#f9cd22",
        "MediumSeaGreen",
        "#e94e19",
        "#203b75",
        "#cc0028",
    ],


    [
        "#000000",
        "#f1594a",
        "#14a160",
        "#acc1bc",
        "#d38e1a",
    ],
    [
        "#433D5F",
        "#67875C",
        "#20191B",
        "#F2F5E3",
        "#F3CB4D",
    ],
    [
        "#2D1922",
        "#FFFCC9",
        "#ED555D",
        "#41B797",
        "#EDA126",
        "#7B5770",
    ],
    [
        "#000000",
        "#4D545A",
        "#E4A13A",
        "#C15E1F",
    ],
    [
        "#1E1A43",
        "#F5D4BC",
        "#4E4973",
        "#CD902A",
        "#BF4A2B",
    ],
    [
        "#191E36",
        "#F0F1F4",
        "#99673A",
        "#F6C0B3",
        "#F40104",
    ],
    [
        "#544E47",
        "#CFC7B9",
        "#000000",
        "#D1AF84",
        "#CEC8B8",
        "#F3B551",
        "#E15147",
        "#4AAD8B",
    ],
    [
        "#1E1A43",
        "#F5D4BC",
        "#4E4973",
        "#CD902A",
        "#BF4A2B",
    ],
    [
        "#2a4d9b",
        "#ffffff",
        "#f0292f",
        "#fb6119",
        "#3e8741",
    ],
    [
        "#3e8740",
        "#fa3219",
        "#fca503",
        "#2969de",
        "#ffffff",
    ],
    [
        "#2619d1",
        "#ebd999",
        "#9b5348",
        "#00592e",
    ],
    [
        "#000000",
        "#f1594a",
        "#2969de",
        "#14a160",
    ],
]
export default Colors